import APIRequest from "./APIRequest";

export const getWishListItem = ({ stopLoading = false }) => {
  return APIRequest.get(`favorites`, { stopLoading });
};
export const toggleWisthListItem = ({ id }) => {
  return APIRequest.post(`favorite/toggle?product_id=${id}`, {
    stopLoading: true,
  });
};
export const register = (params) => {
  return APIRequest.post(`auth/register`, params);
};
export const VerifyUser = (params) => {
  return APIRequest.post(`auth/verify-otp`, params);
};
export const ReSendOTP = (params) => {
  return APIRequest.post(`auth/resend-otp`, params);
};
export const editBasicInfo = (params) => {
  return APIRequest.put(`edit/basic`, params);
};
export const changePassword = (params) => {
  return APIRequest.put(`change/password`, params);
};
export const login = (params) => {
  return APIRequest.post(`auth/login`, params);
};
export const logout = () => {
  return APIRequest.post(`logout`);
};
export const resetPasswordRequest = (params) => {
  return APIRequest.post(`password/reset/request`, params);
};
export const resetPassword = (params) => {
  return APIRequest.post(`password/reset`, params);
};

// New API functions for the updated endpoints
export const forgotPassword = (params) => {
  return APIRequest.post(`auth/forgot-password`, params);
};
export const resetPasswordNew = (params) => {
  return APIRequest.post(`auth/reset-password`, params);
};
export const getUserDetail = (params) => {
  return APIRequest.get(`user/my-details`, params);
};
export const getMySubscription = (params) => {
  return APIRequest.get(`user/my-subscriptions`, params);
};

